<div mat-dialog-content>
    <div class="fileGroup-container-button">
        <button mat-icon-button (click)="onClose()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <app-fileGroupNew (closeDialog)="onClose()" [fileGroupId]="fileGroupId"></app-fileGroupNew>
</div>